const LISTING_PAGE_EXPERIMENTS_LAYER = 'listing_page_experiments';

// Statsig's Events

export const STATSIG_EVENT_NAMES = {
    LISTING_APP_PAGE_VIEW: 'Listing - App - View - Page',
    LISTING_CONVERSION_BAR_CTA_CLICK: 'Listing - conversionBar - Click - CTA',
    LISTING_TICKET_SELECTION_VIEW:
        'Listing - Conversion Bar - Ticket Selection - View',
};

// Heap ID's

export const LISTING_HEAP_IDS = {
    CHILD_EVENTS_DROPDOWN: 'Listing - Date - Child Events Dropdown - Click',
    CHECKOUT_BUTTON: 'Conversion Bar - Checkout Button',
    CREATOR_TOP_BANNER_EDIT: 'Creator Top Banner - Edit',
    CTA_RSVP_MAYBE: 'Listing - Conversion Bar - RSVP Maybe - Click',
    CTA_RSVP_NO: 'Listing - Conversion Bar - RSVP No - Click',
    DESCRIPTIVE_ORGANIZER:
        'Listing - Descriptive Organizer Panel - Follow - Click',
    FAQS_DROPDOWN: 'FAQs - Dropdown',
    HERO_SHARE_EVENT: 'Listing - Hero - Share - Click',
    HIDE_MAP: 'Listing - Hide Map - Button - Click',
    LEFT_ARROW_HERO_CAROUSEL: 'Hero Content - Hero Carousel - Left',
    MAP_DRIVE: 'Listing - Map - Drive - Click',
    MAP_WALK: 'Listing - Map - Walk - Click',
    MAP_BUS: 'Listing - Map - Bus - Click',
    MAP_BIKE: 'Listing - Map - Bike - Click',
    MAP_ZOOM_CHANGE: 'Listing - Map - Zoom - Change',
    MORE_COLLECTIONS_THAT_FEATURE_EVENT:
        'More Collections That Feature This Event - View more collections Button',
    ONLINE_EVENT_ACCESS_BUTTON:
        'Listing - Online Location - Access the Event - Click',
    ORGANIZER_FACEBOOK:
        'Listing - Organizer Panel - Organizer Facebook - Click',
    ORGANIZER_NAME: 'Listing - Organizer Panel - Organizer Name - Click',
    ORGANIZER_TWITTER: 'Listing - Organizer Panel - Organizer Twitter - Click',
    ORGANIZER_WEBSITE: 'Listing - Organizer Panel - Organizer Website - Click',
    PART_OF_A_COLLECTION:
        'Hero Content - Part of /Featured in Collection/s button',
    RIGHT_ARROW_HERO_CAROUSEL: 'Hero Content - Hero Carousel - Right',
    SHOW_MAP: 'Listing - Show Map - Button - Click',
    SIMPLIFIED_ORGANIZER:
        'Listing - Simplified Organizer Panel - Follow - Click',
};
export const SALES_STATUS_ON_SALE = 'on_sale';

// Statsig's Repeating Events Experiment

export const LISTING_PAGE_REPEATING_CHILD_EVENTS_EXPERIMENT = {
    defaultValue: false || 'false',
    layer: LISTING_PAGE_EXPERIMENTS_LAYER,
    param: 'repeating_child_events_slider',
};

// Statsig's Tabs experiment
export const LISTING_PAGE_TABS_EXPERIMENT = {
    defaultValue: false,
    layer: LISTING_PAGE_EXPERIMENTS_LAYER,
    param: 'display_tabs',
};

// Statsig's Personalization Secondary Nav Experiment
export const LISTING_PAGE_PERSONALIZATION_SECONDARY_NAV_EXPERIMENT = {
    defaultValue: 0,
    layer: LISTING_PAGE_EXPERIMENTS_LAYER,
    param: 'secondary_nav_type',
    event: 'Listing - Secondary Nav - Link - Click',
};
